import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import { PortfolioWithResolve } from '../c/Portfolio';
import Me from '../Me';

export default (props) => {
    const me = Me.get()
    let chart = false;
    if (me && me.User && me.User.IsGod) {
        chart = true;
    }

    return (
        <Container className="p-0">
            <Row className="ad_notification_box pb-4 pt-3">
                <Col md="12" className="ad_game_box">
                    <PortfolioWithResolve show_title={true} include_chart={chart} portfolio_id={props.portfolio_id} allow_previously_traded={true} hideValues={true}/>
                </Col>
            </Row>
            <div className="p-4"/>
        </Container>
    )
};



// WEBPACK FOOTER //
// ./src/p/Portfolio.js